import { Typography } from '@timeedit/ui-components/antd';
import type { LinkProps } from '@timeedit/ui-components/antd/typography/Link';

const AddButton = (props: LinkProps) => {
  return (
    <div style={{ display: 'flex', height: '30px', alignItems: 'center' }}>
      <Typography.Link {...props}>Add</Typography.Link>
    </div>
  );
};

export default AddButton;
